// Minimal HTML sanitiser for email-template previews. Adopted from
// AmsterdamBoat's frontend/src/modules/admin/email-templates/utils/sanitize.ts -
// strips script tags, event-handler attributes, and javascript: URLs. Not a
// full general-purpose sanitiser; intended for admin-authored HTML rendered
// inside a sandboxed <iframe srcdoc>.

const SCRIPT_TAGS = /<script\b[^>]*>[\s\S]*?<\/script>/gi;
const ON_ATTRS = /\son\w+="[^"]*"|\son\w+='[^']*'|\son\w+=\S+/gi;
const JAVASCRIPT_URLS = /(href|src|action|formaction|background)=("|')\s*javascript:[^"']*\2/gi;

export function sanitizeEmailHtml(html: string): string {
  return html
    .replace(SCRIPT_TAGS, '')
    .replace(ON_ATTRS, '')
    .replace(JAVASCRIPT_URLS, '$1="#"');
}
